module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', [_vm._v("Basic - small")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": function($event) {
        _vm.smallModalDemoVisible = true
      }
    }
  }, [_vm._v("Click to open small modal")])], 1), _vm._v(" "), _c('h3', [_vm._v("Basic - medium")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": function($event) {
        _vm.mediumModalDemoVisible = true
      }
    }
  }, [_vm._v("Click to open medium modal")])], 1), _vm._v(" "), _c('h3', [_vm._v("Basic - large")]), _vm._v(" "), _c('div', {
    staticClass: "mt--text-right"
  }, [_c('mt-button', {
    attrs: {
      "type": "secondary-gray"
    },
    on: {
      "click": function($event) {
        _vm.largeModalDemoVisible = true
      }
    }
  }, [_vm._v("Click to open large modal")])], 1), _vm._v(" "), _c('h2', [_vm._v("Style")]), _vm._v(" "), _c('h3', [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.basic,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('h3', [_vm._v("Sizing")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.small,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.medium,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left large mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.large,
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', [_vm._v("Position")]), _vm._v(" "), _c('div', {
    staticClass: "left large mt--bg--neutrals-light-gray-01 imgbox"
  }, [_c('img', {
    attrs: {
      "src": _vm.position,
      "alt": ""
    }
  })]), _vm._v(" "), _c('mt-modal', {
    attrs: {
      "visible": _vm.mediumModalDemoVisible,
      "title": "Title",
      "closeVisible": true,
      "icon": false
    },
    on: {
      "update:visible": function($event) {
        _vm.mediumModalDemoVisible = $event
      },
      "handleBeforeModalClose": _vm.handleBeforeModalClose,
      "open": _vm.openModal
    }
  }, [_c('div', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.mediumModalDemoVisible = false
      }
    }
  }, [_vm._v("확인")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "subtle"
    },
    on: {
      "click": function($event) {
        _vm.mediumModalDemoVisible = false
      }
    }
  }, [_vm._v("취소")])], 1)]), _vm._v(" "), _c('mt-modal', {
    attrs: {
      "visible": _vm.smallModalDemoVisible,
      "size": "small",
      "title": "Title",
      "closeVisible": true,
      "icon": false
    },
    on: {
      "update:visible": function($event) {
        _vm.smallModalDemoVisible = $event
      },
      "handleBeforeModalClose": _vm.handleBeforeModalClose,
      "open": _vm.openModal
    }
  }, [_c('div', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.smallModalDemoVisible = false
      }
    }
  }, [_vm._v("확인")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "subtle"
    },
    on: {
      "click": function($event) {
        _vm.smallModalDemoVisible = false
      }
    }
  }, [_vm._v("취소")])], 1)]), _vm._v(" "), _c('mt-modal', {
    attrs: {
      "visible": _vm.largeModalDemoVisible,
      "size": "large",
      "title": "Title",
      "closeVisible": true,
      "icon": false
    },
    on: {
      "update:visible": function($event) {
        _vm.largeModalDemoVisible = $event
      },
      "handleBeforeModalClose": _vm.handleBeforeModalClose,
      "open": _vm.openModal
    }
  }, [_c('div', [_vm._v("Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('mt-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.largeModalDemoVisible = false
      }
    }
  }, [_vm._v("확인")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "small",
      "type": "subtle"
    },
    on: {
      "click": function($event) {
        _vm.largeModalDemoVisible = false
      }
    }
  }, [_vm._v("취소")])], 1)])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Modals")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Buttons bar: #F6F7FA")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Subtle button: #485464  opacity 80%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Corner radius: 4px")]), _vm._v(" "), _c('p', [_vm._v("Width: 400px")]), _vm._v(" "), _c('p', [_vm._v("Height: auto")]), _vm._v(" "), _c('p', [_vm._v("Maximum height: 600px")]), _vm._v(" "), _c('p', [_vm._v("border: 0.5px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 28px")]), _vm._v(" "), _c('p', [_vm._v("Line height: 36px")]), _vm._v(" "), _c('p', [_vm._v("Font size(sentence): 16px")]), _vm._v(" "), _c('p', [_vm._v("Line height(sentence): 24px")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00d100ae","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals.vue
// module id = nHPa
// module chunks = 0